// components
import { styled as muiStyled, Box, BoxProps } from '@mui/material';
import styled from 'styled-components';

import { FIRST_CELL_WIDTH } from './const';

export const StyledRosterViewTableBox = muiStyled(Box)<BoxProps>(
  ({ theme }) => ({
    paddingRight: theme.spacing(2)
  })
);

export const HeaderStyles = styled.div`
  .main-nav {
    margin-bottom: 10px;
  }

  .filters {
    padding-left: 0 !important;
    vertical-align: bottom !important;
  }

  .planunit-selector {
    .MuiAutocomplete-root {
      min-width: calc(${FIRST_CELL_WIDTH} - 8px);
    }
  }

  .side-container {
    width: 50%;
  }

  .print-roster-btn {
    margin: 0 10px;
  }

  .mode-selector {
    width: 220px;
    margin-left: 10px;
  }

  .publication-info {
    width: 300px;
    color: red;
    display: inline-block;
  }
`;
